import { useSelector } from "react-redux";
import store from "../../storeWire";
import { getAdminOrderList, setAdminOrderList } from "../../store/slice/model/Admin/Order";
import { getAdminOrderInsightInfo, } from "../../store/slice/model/Admin/OrderInsightInfo";
import { getAdminOrderInsightList } from "../../store/slice/model/Admin/OrderInsightList";
import OrderAdminRepository from "../../repository/Admin/OrderAdminRepository";

export function useAdminOrderStore() {
  const adminOrderList = useSelector((state) => state.entities.model_Admin_Orders_list.adminOrderList)
  const orderTotal = useSelector((state) => state.entities.model_Admin_Orders_list.totalRecords)
  const orderInsightInfo = useSelector((state) => state.entities.model_Admin_Orders_insight_info.orderInsightInfo)
  const insightTotal = useSelector((state) => state.entities.model_Admin_Orders_insight_list.totalRecords)
  const orderInsightList = useSelector((state) => state.entities.model_Admin_Orders_insight_list.orderInsightList)
  const orderTotalPrice= useSelector((state) => state.entities.model_Admin_Orders_insight_list.orderTotal)

  const data = {
    adminOrderList,
    orderTotal,
    insightTotal,
    orderInsightInfo,
    orderInsightList,
    orderTotalPrice
  };

  const fetch = {
    get_admin_orders: async (params) => {
      return store.dispatch(getAdminOrderList(params));
    },
    get_admin_order_insight_info: async (params) => {
      return store.dispatch(getAdminOrderInsightInfo(params))
    },
    get_admin_order_insight_list: async (params) => {
      return store.dispatch(getAdminOrderInsightList(params))
    },
    get_order_insight_export_all: async (params) => {
      return new OrderAdminRepository().getOrderInsightExportAll(params);
    }
  };

  const set = {
    clear_admin_orders: async () => {
      return store.dispatch(setAdminOrderList([]));
    },
    clear_order_insight_info: async (params) => {
      return store.dispatch(getAdminOrderInsightInfo({}))
    },
    clear_order_insight_list: async (params) => {
      return store.dispatch(getAdminOrderInsightList([]))
    },
    reprocess_order: async (params) => {
      return new OrderAdminRepository().adminOrderReprocess(params)
    }
  };

  return [data, fetch, set];
}